// extracted by mini-css-extract-plugin
module.exports = {"option":"JcG1Y","list":"fGQEF","name":"hdMNm"};